// Components Global
import SiteDisplayContainer from '../../../../components/SitesManage/Sites/containers/SiteDisplayContainer'

export default SiteDisplayContainer
